<template>
  <md-icon v-if="svg" :md-svg="svg" :size="size"></md-icon>
  <md-icon class="vdl-icon" v-else-if="icon && customIcon"
    ><span :class="`vdl-icon-${icon}`" v-html="html"></span
  ></md-icon>
</template>
<script lang="ts">
import { Options as Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  name: 'vdl-icon',
})
export default class Icon extends Vue {
  @Prop({ default: '' })
  icon: string;
  @Prop()
  mdIcon: Boolean;
  @Prop()
  customIcon: Boolean;
  @Prop({ default: '' })
  html: string;
  @Prop({ default: '' })
  svg: string;

  @Prop()
  size: number;
}
</script>
